import RightPopupComponent from "components/RightPopup";

import ControlData from "components/ControlData";

import { ReactComponent as PlusIcon } from 'icons/buttons/plus.svg';
import { ReactComponent as CloseIcon } from 'icons/components/bufferClose.svg';

import '../index.less';
import '../themes/default.less';

export default class Parking extends RightPopupComponent {

    render() {
        const { modePark, changeModePark, vehicles, addVehicles, removeVehicles, updateVehicles } = this.props;

        return (<div className="flex gap16 col" >
            <ControlData
                defaultMode={modePark}
                items={["Не нужна", "Спрашивать", "Сразу оформлять"]}
                onClick={changeModePark} />
            {modePark === 1 && <div className="flex col gap16">
                {(vehicles || []).map((it, i) => (<div key={"field_" + i} className="flex col gap8">
                    <div className="flex gap16">
                        <div className="flex w100 gap8">
                            {this.insertInput({
                                value: it.mark,
                                label: "Марка автомобиля",
                                itemStyle: "flex1",
                                placeHolder: "Lexus RX 300",
                                onChange: updateVehicles.bind(this, i, "mark")
                            })}
                            {this.insertInput({
                                value: it.number,
                                itemStyle: "flex1",
                                label: "Госномер ТС",
                                placeHolder: "А 555 EE 989",
                                onChange: updateVehicles.bind(this, i, "number")
                            })}
                        </div>
                        <div className="flex centerV" onClick={removeVehicles.bind(this, i)}>
                            <CloseIcon className="close hand" />
                        </div>
                    </div>
                    {vehicles.length > 1 && i === 0 && <div className="gray2 text p2">Основной автомобиль</div>}
                </div>))}
                <div className="addNewField flex gap8 text p1 hand" onClick={addVehicles.bind(this)}>
                    <PlusIcon />
                    <div className="addNewFieldTitle">
                        {this.tr("Добавить автомобиль")}
                    </div>
                </div>
            </div>
            }
        </div>
        );
    }
}

